import { User } from '@/api/model/user'
import { BaseModel } from '@/api/base-model'
import { UserTargetAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'

export class UserTarget extends BaseModel<UserTarget> {
    protected collectionName = UserTargetAPI.collectionName

    constructor(
        public user: User|null,
        public id: string,
        public fromDate: Date,
        public untilDate: Date,
        public referralPipeline: Pipeline|null,
        public referralType: string,
        public orderType: string,
        public direction: string,
        public quantity: number,
        public turnover: number,
        public createdAt: Date|null,
        public updatedAt: Date|null,
    ) { super(id) }

    static fromData(data: any): UserTarget {
        if (data === null || typeof data === 'string' || data instanceof UserTarget) {
            return data
        }

        return new UserTarget(
            data.user ? User.fromData(data.user) : null,
            data.id,
            data.fromDate,
            data.untilDate,
            data.referralPipeline ? Pipeline.fromData(data.referralPipeline) : null,
            data.referralType,
            data.orderType,
            data.direction,
            data.quantity,
            data.turnover,
            data.createdAt,
            data.updatedAt,
        )
    }
}
